export default {
    'Operation successful': 'Operate successful',
    'Automatic cancellation due to duplicate request:': 'Automatic cancellation due to duplicate requests:',
    'Interface redirected!': 'Interface redirected!',
    'Incorrect parameter!': 'Incorrect parameter!',
    'You do not have permission to operate!': 'You have no permission to operate!',
    'Error requesting address:': 'Error requesting address:',
    'Request timed out!': 'Request timeout!',
    'The same data already exists in the system!': 'The same data already exists on the system!',
    'Server internal error!': 'Internal server error!',
    'Service not implemented!': 'Service unrealized!',
    'Gateway error!': 'Gateway error!',
    'Service unavailable!': 'Service unavailable!',
    'The service is temporarily unavailable Please try again later!': 'The service is temporarily unavailable, please try again later!',
    'HTTP version is not supported!': 'HTTP version is not Unsupported!',
    'Abnormal problem, please contact the website administrator!': 'Abnormal problems, please contact the website administrator!',
    'Network request timeout!': 'Network request timeout!',
    'Server exception!': 'Server-side exceptions!',
    'You are disconnected!': 'You are disconnected!',
}
